import { } from '@fortawesome/free-regular-svg-icons';
import React, { useEffect, useState } from 'react';
import NavMenu from '../component/NavMenu';
import { ProfileCard } from '../component/ProfileCard';
import './bubble.css';
const MainLayout = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 100);

        return () => clearTimeout(timer);
    }, [children]);
    return (
        <div >
            <div className="waves-container">
                <svg
                    className="waves"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                    shapeRendering="auto"
                >
                    <defs>
                        <path
                            id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                        />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                    </g>
                </svg>
            </div>
            <div className="min-h-screen flex flex-col md:flex-row">
                <NavMenu />
                <div className="flex flex-col justify-center ">
                    <ProfileCard />
                </div>
                <main className="flex-1 flex items-center justify-center">
                    <div
                        className={`bg-white shadow rounded-lg p-6 mb-2 md:mb-0 mt-1 md:mt-0 mx-2   h-[91vh] sm:min-h-[80vh] sm:max-h-[70vh] sm:min-w-[60vw] sm:max-w-[60vw]  overflow-auto transition-transform duration-300 ${!isLoading ? 'translate-x-0' : 'translate-x-full'}`}
                    >
                        {children}
                    </div>


                </main>
            </div >

        </div >
    );
};

export default MainLayout;